import React from 'react';
import { Typography, Card, Spin } from 'antd';
import { usePageManager } from '../../../../contexts/PageManager/Provider';
import IconAdmin from '~/assets/images/icons/icone256-admin.png';

const { Title, Text } = Typography;

export default function Institution() {
  const { totalInstitution, totalInstitutionLoading } = usePageManager();

  const Field = ({ label, value }) => {
    return (
      <div style={{ display: 'flex', gap: 4, alignItems: 'center' }}>
        <Text>{label}:</Text>
        {value ? (
          <Text style={{ color: '#143c6d', fontWeight: 'bold' }}>{value}</Text>
        ) : (
          <Spin size="small" />
        )}
      </div>
    );
  };

  return (
    <Card bodyStyle={{ padding: 0 }}>
      <div
        style={{
          padding: '6px',
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
          backgroundColor: '#143c6d',
          borderTopRightRadius: '4px',
          borderTopLeftRadius: '4px',
        }}
      >
        <Title level={5} style={{ margin: 0, padding: 0, color: 'white' }}>
          Instituição
        </Title>
      </div>
      <div
        style={{
          display: 'flex',
          justifyContent: 'flex-start',
          padding: '0px 8px',
          alignItems: 'center',
          gap: 8,
        }}
      >
        <div>
          <img src={IconAdmin} style={{ width: 64 }} alt="..." />
        </div>
        <div>
          <Field
            label="Unidades"
            value={
              totalInstitutionLoading ? null : totalInstitution.totalUnities
            }
          />
          <Field
            label="Modelos de documentos"
            value={
              totalInstitutionLoading ? null : totalInstitution.totalDocModels
            }
          />
          <Field
            label="Tipos de processos"
            value={
              totalInstitutionLoading
                ? null
                : totalInstitution.totalProcessesKinds
            }
          />
        </div>
      </div>
    </Card>
  );
}
